export default function checkExpiryStatus() {
  const cookie = document.cookie
    .split("; ")
    .find((cookie) => cookie.startsWith("bm_banner_type"));
  const banner = document.querySelector(".sub-expiry-banner");
  if (cookie == null && banner) {
    banner.classList.remove("d-none");
  }
}
